import { MempolChainProvider, SupportedNetwork } from "@cat-protocol/cat-sdk";
import { boardcast } from "./api";


export default class MyChainProvider extends MempolChainProvider {

    constructor(public readonly userAddr: string, public readonly tokenId: string, public network: SupportedNetwork) {
        super(network);
    }

    override async broadcast(txHex: string): Promise<string> {
        const res = await boardcast(txHex, this.userAddr, this.tokenId, this.network);
        return res.txid;

    }
}